import { v4 as uuidv4 } from 'uuid';
import LayerStore from '../../Layer/_stores/LayerStore';
import { LayerListAction, LayerListActionType } from '../_actions/LayerListActions';
import { ModuleListAction, ModuleListActionType } from '../../ModuleList/_actions/ModuleListActions';
import LayerListStore from '../_stores/LayerListStore';
import { HIDAction } from '../../HID/_actions/HIDActions';

const LayerListReducer = (store:LayerListStore = new LayerListStore(), action: LayerListAction | ModuleListAction | HIDAction):LayerListStore => {
	const selectedLayerId = store.get('selectedLayerId');

	switch (action.type) {
		case LayerListActionType.OnLayerAdd:
			const id:string = uuidv4();
			const layerStore:LayerStore = new LayerStore({
				id: id,
				name:"Layer " + store.get('layers').count()
			});
			return store.withMutations(store => {
				store.set('layers', store.get('layers').set(id, layerStore));
				store.set('layersOrder', store.get('layersOrder').add(id));
				store.set('selectedLayerId', id);
			});
		
		case LayerListActionType.OnLayerRemove:
			return store.withMutations(store => {
				store.set('layers', store.get('layers').delete(action.id));
				store.deleteIn(['layersOrder', action.id]);
				store.set('selectedLayerId', store.get('layers').keySeq().last());
			});
		
		case LayerListActionType.OnLayerSelect:
			return store.set('selectedLayerId', action.id);

		case LayerListActionType.OnLayerMove:
			let layerIndex = store.get('layersOrder').valueSeq().keyOf(action.id);
			const without = store.removeIn(['layersOrder', action.id]);
			const a = without.get('layersOrder').take(layerIndex + action.offset);
			const b = without.get('layersOrder').skip(layerIndex + action.offset);
			return store.set('layersOrder', a.add(action.id).merge(b));

		case LayerListActionType.OnLayerRename:
			return store.setIn(['layers', action.id, 'name'], action.name);

		case LayerListActionType.OnLayerVisibility:
			return store.setIn(['layers', action.id, 'visible'], action.visible);

		case LayerListActionType.OnLayerListVisibilityToggle:
			let visible = store.get('opened');
			return store.setIn(['opened'], !visible);

		case LayerListActionType.OnLayerListVisibility:
			return store.setIn(['opened'], action.visible);
	}

	switch (action.type) {
		case ModuleListActionType.OnModuleAdd:
			return store.setIn(['layers', selectedLayerId, 'modules'], store.get('layers').get(selectedLayerId).get('modules').add(action.id))

		case ModuleListActionType.OnModuleRemove:
			return store.setIn(['layers', selectedLayerId, 'modules'], store.get('layers').get(selectedLayerId).get('modules').delete(action.id))

		case ModuleListActionType.OnModuleMove:
			const without = store.removeIn(['layers', selectedLayerId, 'modules', action.id]);
			const a = without.get('layers').get(selectedLayerId).get('modules').take(action.position);
			const b = without.get('layers').get(selectedLayerId).get('modules').skip(action.position);
			return store.setIn(['layers', selectedLayerId, 'modules'], a.add(action.id).merge(b));
	}

	return store;
}

export default LayerListReducer